/* eslint-disable */
import Vue from 'vue'
import Vuesax from 'vuesax'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n



import '@/styles/index.scss' // global css
import 'material-icons/iconfont/material-icons.css'
import '@/assets/fonts/docutag/css/docutag.css'
import 'vuesax/dist/vuesax.css'

import App from './App'
import router from './router'
import store from './store'
import MIcon from '@/components/Icon/MIcon.vue'

import '@/icons' // icon
import '@/permission' // permission control

Vue.use(ElementUI, { locale })

Vue.component('m-icon', MIcon)

Vue.prototype.$NETWORK_ID = process.env.NETWORK_ID

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})


Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: '#023373'
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js